import { useEffect } from 'react';
import { useAuth } from '../hooks/useAuth.tsx';
import { serverAccessor } from '../accessors/serverAccessor.ts';
import { useNavigate } from 'react-router';

export const AuthLoader = ({ children }: { children: React.ReactNode; }) => {
    const { login, logout } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const refresh = async () => {
            try {
                const res = await serverAccessor.refreshAuthToken();
                login(res.accessToken); // store in AuthContext

            } catch (err) {
                console.warn('Refresh token expired or invalid. Logging out.');
                logout();               // Clear auth state
                navigate('/login');     // Redirect to login page
            }
        };
        refresh();
    }, []);

    return <>{children}</>;
};